import {
  productsCategoriesSearchParamsSchema,
  productsCategoriesSearchParamsSchemaDefaults,
} from "../../categories/[...slugs]/ProductsCategoriesSearchParamsSchema";
import { productsSearchParamsSchema, productsSearchParamsSchemaDefaults } from "../SITESEARCH/ProductsSearchParamsSchema";

const searchSchemas = {
  products: {
    schema: productsSearchParamsSchema,
    defaults: productsSearchParamsSchemaDefaults,
  },
  categories: {
    schema: productsCategoriesSearchParamsSchema,
    defaults: productsCategoriesSearchParamsSchemaDefaults,
  },
};
export { searchSchemas };
